export const apiBaseUrl = 'https://api.audiens-bourses-etudes.org'
